import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DeviceMeasurement } from '../../../../model/device-measurement';
import { AssetMeasurement } from '../../../../model/asset-measurement';
import { Kpi } from '../../../../model/kpi';
import { SortOrder } from "../../../../model/sort-order";
import { DevicesService } from "../../../../services/devices.service";
import { AssetsService } from "../../../../services/assets.service";
import { KpisService } from "../../../../services/kpis.service";
import { KpiPersistRequestFilters } from "../../../../model/requests/kpi-persist-request-filters";
import { KpiPersistRequestEnabledFilters } from "../../../../model/requests/kpi-persist-request-enabled-filters";

@Component({
  selector: 'app-kpis-form-confirmation',
  templateUrl: './kpis-form-confirmation.component.html',
  styleUrls: ['./kpis-form-confirmation.component.scss']
})
export class KpisFormConfirmationComponent {

  @Input() kpiInfoForm: FormGroup;
  @Input() mode: 'create' | 'edit';
  @Input() deviceMeasurements: DeviceMeasurement[];
  @Input() assetMeasurements: AssetMeasurement[];
  @Input() kpis: Kpi[];
  @Input() filters: KpiPersistRequestFilters;
  @Input() enabledFilters: KpiPersistRequestEnabledFilters;

  public filteredDeviceMeasurements: DeviceMeasurement[];
  public filteredDeviceMeasurementsFirst: number = 0;
  public filteredDeviceMeasurementsRows: number = 5;
  public filteredTotalDeviceMeasurements: number = 0;
  public filteredLoadingDeviceMeasurements: boolean = false;
  public filteredAssetMeasurements: AssetMeasurement[];
  public filteredAssetMeasurementsFirst: number = 0;
  public filteredAssetMeasurementsRows: number = 5;
  public filteredTotalAssetMeasurements: number = 0;
  public filteredLoadingAssetMeasurements: boolean = false;
  public filteredKpis: Kpi[];
  public filteredKpisFirst: number = 0;
  public filteredKpisRows: number = 5;
  public filteredTotalKpis: number = 0;
  public filteredLoadingKpis: boolean = false;

  public deviceMeasurementsFirst: number = 0;
  public deviceMeasurementsRows: number = 5;
  public assetMeasurementsFirst: number = 0;
  public assetMeasurementsRows: number = 5;
  public kpisFirst: number = 0;
  public kpisRows: number = 5;

  constructor(
    private devicesService: DevicesService,
    private assetsService: AssetsService,
    private kpisService: KpisService
  ) {}

  public onFilteredDeviceMeasurementsPageChange(event): void {
    this.filteredLoadingDeviceMeasurements = true;
    this.filters.deviceMeasurementFilters.sortField = event.sortField;
    this.filters.deviceMeasurementFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.devicesService.getCommonDeviceMeasurements(
      this.filters.deviceMeasurementFilters, (event.first / event.rows), event.rows
    ).toPromise().then(response => {
      this.filteredDeviceMeasurements = response.deviceMeasurements;
      this.filteredTotalDeviceMeasurements = response.totalElements;
      this.filteredLoadingDeviceMeasurements = false;
    });
  }

  public onFilteredAssetMeasurementsPageChange(event): void {
    this.filteredLoadingAssetMeasurements = true;
    this.filters.assetMeasurementFilters.sortField = event.sortField;
    this.filters.assetMeasurementFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.assetsService.getCommonAssetMeasurements(
      this.filters.assetMeasurementFilters, (event.first / event.rows), event.rows
    ).toPromise().then(response => {
      this.filteredAssetMeasurements = response.assetMeasurements;
      this.filteredTotalAssetMeasurements = response.totalElements;
      this.filteredLoadingAssetMeasurements = false;
    });
  }

  public onFilteredKpisPageChange(event): void {
    this.filteredLoadingKpis = true;
    this.filters.kpiFilters.sortField = event.sortField;
    this.filters.kpiFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.kpisService.getKpis(
      (event.first / event.rows), event.rows, this.filters.kpiFilters
    ).toPromise().then(response => {
      this.filteredKpis = response.kpis;
      this.filteredTotalKpis = response.totalElements;
      this.filteredLoadingKpis = false;
    });
  }

}
